import { Divider } from '@eventbrite/eds-divider';
import { Illustration } from '@eventbrite/eds-illustration';
import React from 'react';
import './EmptyState.scss';

interface EmptyStateProps {
    containerClassname?: string;
    illustrationType?: React.ReactNode;
    children?: React.ReactNode;
}

export const EmptyState = (props: EmptyStateProps) => {
    return (
        <>
            <div className="eds-l-pad-bot-8">
                <Divider color="ui-200" />
            </div>
            <section
                className={`empty-state ${props?.containerClassname || ''}`}
            >
                <div className="empty-state__body">{props.children}</div>
                <div className="empty-state__graphic">
                    <Illustration
                        width="100px"
                        height="100px"
                        type={props.illustrationType}
                    />
                </div>
            </section>
        </>
    );
};
